import React, { useState, useEffect } from 'react';
import Select, { components } from "react-select";
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from "react-sortable-hoc";

function arrayMove(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}

const SortableMultiValue = SortableElement(props => {
    const onMouseDown = e => {
        e.preventDefault();
        e.stopPropagation();
    };
    const innerProps = { onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableSelect = SortableContainer(Select);

function LocalAutoSuggest(props) {
    const [selectedValue, setSelectedValue] = useState(null);
    const [defaultOptions, setDefaultOptions] = useState(null);

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newValue = arrayMove(selectedValue, oldIndex, newIndex);
        setSelectedValue(newValue);
        props.onChange(props.component_name, newValue);
    };


    useEffect(() => {
        setSelectedValue(props.defaultVal);
        setDefaultOptions(props.options);
    }, [props.defaultVal, props.options]);

    // handle selection
    const handleChange = value => {
        setSelectedValue(value);
        props.onChange(props.component_name, value);
    }


    const colourStyles = {
        container: provided => ({
            ...provided,
            width: '60%',
        }),
    };

    return (
        <SortableSelect
            axis="xy"
            distance={4}
            getHelperDimensions={({ node }) => node.getBoundingClientRect()}
            onSortEnd={onSortEnd}
            value={selectedValue}
            onChange={handleChange}
            options={defaultOptions}
            isMulti={true}
            components={{
                MultiValue: SortableMultiValue
            }}
            styles={colourStyles}
            maxMenuHeight={100}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.filter
    };
}

export default connect(mapStateToProps, null)(LocalAutoSuggest)
// export default LocalAutoSuggest;